'use client';

import BottomSheet from '@/app/academy/components/bottom-sheet';
import { cn } from '@/lib/utils';
import { useMemberStore } from '@/stores/member.store';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';

import WrittenPrepIdVerificationSheet from './written-prep-id-verification-sheet.client';
import WrittenPrepPhotoSpecSheet from './written-prep-photo-spec-sheet.client';
import WrittenSheetHeader from './written-sheet-header.client';

type PrepSupplementSheet = 'id_verification' | 'photo_spec';

const PREP_SHEET_LABEL: Record<PrepSupplementSheet, string> = {
  id_verification: '신분증 인증 범위',
  photo_spec: '증명사진 규격',
};

interface WrittenPrepSupplementBarAndSheetProps {
  /** 버튼 행 래퍼에 추가 클래스(예: 하단 고정 시 패딩) */
  className?: string;
}

/**
 * 학과시험 > 시험 안내 준비물 블록과 동일한
 * 「신분증 인증 범위」「증명사진 규격」 버튼 + BottomSheet.
 */
export default function WrittenPrepSupplementBarAndSheet({
  className,
}: WrittenPrepSupplementBarAndSheetProps) {
  const [openSheet, setOpenSheet] = useState<PrepSupplementSheet | null>(null);
  const searchParams = useSearchParams();
  const isAppFromQuery = searchParams.get('isApp')?.toLowerCase() === 'true';
  const isAppConnected = useMemberStore((s) => s.isAppConnected);
  const isApp = isAppFromQuery || isAppConnected;
  const sheetFixHeight = isApp ? 'calc(100dvh - 30px)' : '90dvh';

  return (
    <>
      <div className={cn('-mx-5 flex gap-2 bg-[#F5F5FA] px-5 py-4', className)}>
        <button
          type="button"
          className="cursor-pointer typo-14 h-[38px] flex-1 bg-252530 py-3 font-semibold text-white shadow-[0_2px_6px_rgba(0,0,0,0.12)]"
          onClick={() => setOpenSheet('id_verification')}
        >
          {PREP_SHEET_LABEL.id_verification}
        </button>
        <button
          type="button"
          className="cursor-pointer typo-14 h-[38px] flex-1 bg-ffd42f py-3 font-semibold text-222222 shadow-[0_2px_6px_rgba(0,0,0,0.08)]"
          onClick={() => setOpenSheet('photo_spec')}
        >
          {PREP_SHEET_LABEL.photo_spec}
        </button>
      </div>

      <BottomSheet
        isOpen={openSheet !== null}
        onClose={() => setOpenSheet(null)}
        hideHeader={false}
        hideHandleMargin
        bgColor="#ffffff"
        fixHeight={sheetFixHeight}
        headerContent={
          openSheet ? (
            <WrittenSheetHeader
              title={PREP_SHEET_LABEL[openSheet]}
              onClose={() => setOpenSheet(null)}
            />
          ) : undefined
        }
      >
        {openSheet === 'photo_spec' ? (
          <WrittenPrepPhotoSpecSheet />
        ) : openSheet === 'id_verification' ? (
          <WrittenPrepIdVerificationSheet />
        ) : null}
      </BottomSheet>
    </>
  );
}
